import { render, staticRenderFns } from "./OrganizationsCard.vue?vue&type=template&id=79d05580&scoped=true&"
import script from "./OrganizationsCard.vue?vue&type=script&lang=js&"
export * from "./OrganizationsCard.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationsCard.vue?vue&type=style&index=0&id=79d05580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d05580",
  null
  
)

export default component.exports